import React from "react";
import { Typography } from "@material-tailwind/react";

export default function CardSkeleton() {
  return (
    <div className="flex items-center justify-center my-5">
      <div className="w-[20%] h-[20%] p-4 text-center bg-white border border-gray-200 shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700 absolute flex items-center justify-center gap-5">
        <div>
          <Typography
            as="div"
            variant="h1"
            className="mb-4 h-[20px] w-[20px] rounded-lg bg-gray-300 flex items-center justify-center"
          >
            &nbsp;
          </Typography>
        </div>
      </div>
    </div>
  );
}
